module.exports = __webpack_public_path__ + "media/goforajourney/img/spain-card-b476bfbf05e3c50e0cc0cb322ee37283.webp";